import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingRecord } from 'components/dynamic/dynamic-page/DynamicPageRecordSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
};

const payrollHistoryRecordDetailSlice = createSlice({
  name: 'payrollHistoryRecordDetail',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
  },
});

const { setPageInfo, setFormLoading } = payrollHistoryRecordDetailSlice.actions;

export const { setRecord } = payrollHistoryRecordDetailSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: document.id,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data));
            if (!document.status) {
              dispatch(setViewingRecord(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const payrollHistoryRecordDetailReducer = payrollHistoryRecordDetailSlice.reducer;

export default payrollHistoryRecordDetailReducer;
